import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import {MAP_API_KEY} from "./../../config/Config";

const Marker = ({ text }) => <div className="my-map-marker"><span>{text}</span></div>;

export default class MapContainer extends Component {
    static defaultProps = {
        center: {
            lat: 35.739581,
            lng: 51.432568
        },
        zoom: 16
    };
    render() {
        return (
            <div style={{ height: '615px', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: MAP_API_KEY }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                >
                    <Marker
                        lat={35.739581}
                        lng={51.432568}
                        text={'آتلانتیس'}
                    />
                </GoogleMapReact>



            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/map/ContactMap.js